import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button } from "@/components/ui/controls";

export class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("IPF panel render error", error, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="fatal-state">
        <section className="ui-surface fatal-panel" role="alert">
          <span className="eyebrow">Bağlantı sorunu</span>
          <h1>Panel şu anda gösterilemiyor.</h1>
          <p>Oturumunuz korunuyor. Sayfayı yenileyerek tekrar deneyebilirsiniz.</p>
          <Button onClick={() => window.location.reload()}>Tekrar dene</Button>
        </section>
      </main>
    );
  }
}
